import { Colors } from '@blueprintjs/core'
import styled, { css } from 'styled-components'
import { getRgba } from 'ui-lib'

const TableRow = styled.tr<{
  $highlight?: boolean
  $dashboardHighlight?: boolean
}>`
  transition: 0.2s transform ease-in-out;
  ${(p) =>
    p.$highlight
      ? css`
          transform: scale(1.1);
          outline: ${Colors.GRAY3} solid 4px;
          background-color: ${p.theme.darkMode
            ? Colors.DARK_GRAY4
            : Colors.WHITE};
        `
      : ''}
  ${(p) =>
    p.$dashboardHighlight
      ? css`
          background-color: ${getRgba(
            Colors.BLUE2,
            p.theme.darkMode ? 0.6 : 0.3,
          )};
        `
      : ''}
`

export default TableRow
